/* MVS Free Shipping Bar — paste into assets/mvs-free-shipping.js */
(function () {
  // ====== CONFIG ======
  // Set your free shipping threshold IN CENTS (e.g., 6000 = $60.00)
  const FREE_SHIPPING_THRESHOLD = 6000;

  // Currency formatter
  const fmt = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: (Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  });

  // Helpers
  const $all = (sel, root = document) => root.querySelectorAll(sel);
  const getBars = () => $all('[data-freeship]');

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
    return res.json();
  }

  function renderBar(el, cartCents) {
    const track = el.querySelector('.mvs-freeship__track');
    const fill  = el.querySelector('.mvs-freeship__fill');
    const text  = el.querySelector('.mvs-freeship__text');
    if (!track || !fill || !text) return;

    const threshold = FREE_SHIPPING_THRESHOLD;
    const pct = Math.max(0, Math.min(100, (cartCents / threshold) * 100));

    // Prep (neutralize opinionated theme styles)
    fill.style.transformOrigin = 'left center';
    fill.style.willChange = 'width, transform';
    fill.style.display = 'block';
    fill.style.removeProperty('right');
    fill.style.removeProperty('flex');
    fill.style.removeProperty('max-width');

    // Set width with !important so CSS cannot override it
    fill.style.setProperty('width', pct + '%', 'important');

    // Fallback: also apply scaleX so even pinned layouts visually fill
    const scale = pct / 100;
    fill.style.setProperty('transform', `scaleX(${scale})`, 'important');

    if (cartCents >= threshold) {
      text.textContent = 'You unlocked free shipping 🎉';
      el.classList.add('is-complete');
    } else {
      const remaining = threshold - cartCents;
      text.textContent = `You're ${fmt.format(remaining / 100)} away from free shipping`;
      el.classList.remove('is-complete');
    }
  }

  async function refreshBars() {
    const bars = getBars();
    if (!bars.length) return;
    try {
      const cart = await fetchCart();
      // Use total_price so discounts are respected; fallback to items_subtotal_price
      const cents = (typeof cart.total_price === 'number')
        ? cart.total_price
        : (cart.items_subtotal_price || 0);
      bars.forEach(el => renderBar(el, cents));
    } catch (e) {
      console.error('[MVS FreeShip] refresh error', e);
    }
  }

  // ====== Init ======
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshBars, { once: true });
  } else {
    refreshBars();
  }

  // ====== Listeners to keep it in sync ======
  // Custom events some themes/apps fire
  window.addEventListener('cart:updated', refreshBars);
  window.addEventListener('cart:refresh', refreshBars);
  window.addEventListener('cart:change', refreshBars);

  // When the cart drawer is opened via a button (attribute you add on your icon)
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]')) {
      setTimeout(refreshBars, 75);
    }
  });

  // Patch fetch to detect cart API calls (add/change/update/clear)
  const _origFetch = window.fetch;
  window.fetch = function () {
    const out = _origFetch.apply(this, arguments);
    try {
      const url = String(arguments[0] || '');
      if (url.includes('/cart') && !url.endsWith('.css') && !url.endsWith('.js')) {
        out.finally(() => setTimeout(refreshBars, 0));
      }
    } catch (_) {}
    return out;
  };

  // Quantity changes on cart page forms
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el) return;
    if (el.name === 'updates[]' || el.closest('form[action*="/cart"]')) {
      setTimeout(refreshBars, 150);
    }
  });

  // Theme Editor section changes can re-render DOM; re-run
  document.addEventListener('shopify:section:load', refreshBars);
  document.addEventListener('shopify:section:reorder', refreshBars);
  document.addEventListener('shopify:block:select', refreshBars);

  // On full cart page, do one more pass after paint
  if (document.body.classList.contains('template-cart')) {
    requestAnimationFrame(refreshBars);
  }
})();
